<footer>
    <div class="container-fluid py-5">
        <div class="container">
            <div
                class="d-flex justify-content-between align-items-center flex-column flex-md-row border-bottom py-2"
            >
                <div class="">
                    <img
                        class="ms-0 ms-md-3 mb-0"
                        height="40"
                        alt="iChoosr logo"
                        [attr.src]="'footer-logo' | cmsImageSrc | async"
                        [attr.alt]="'footer-logo' | cmsImageAlt | async"
                    />
                    <img
                        class="ms-0 ms-md-3 mb-0"
                        height="40"
                        [attr.src]="'footer-logo-extra-1' | cmsImageSrc | async"
                        [attr.alt]="'footer-logo-extra-1' | cmsImageAlt | async"
                        *ngIf="
                            contentService.valueExists('footer-logo-extra-1')
                                | async
                        "
                    />
                    <img
                        class="ms-0 ms-md-3 mb-0"
                        height="40"
                        [attr.src]="'footer-logo-extra-2' | cmsImageSrc | async"
                        [attr.alt]="'footer-logo-extra-2' | cmsImageAlt | async"
                        *ngIf="
                            contentService.valueExists('footer-logo-extra-2')
                                | async
                        "
                    />
                </div>
                <ul class="nav justify-content-center">
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            [routerLink]="[
                                '/',
                                communityCode,
                                'terms-and-conditions',
                            ]"
                            target="_blank"
                        >
                            {{
                                'terms-and-conditions'
                                    | cmsText
                                    | jpText
                                    | async
                            }}</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            [routerLink]="[
                                '/',
                                communityCode,
                                'privacy-policy',
                            ]"
                            target="_blank"
                        >
                            {{
                                'title-privacy-policy'
                                    | cmsText
                                    | jpText
                                    | async
                            }}</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            [routerLink]="['/', communityCode, 'cookie-policy']"
                            target="_blank"
                        >
                            {{ 'cookie-policy' | cmsText | jpText | async }}</a
                        >
                    </li>
                </ul>
            </div>
            <div class="row mt-3">
                <div class="col-8">
                    <p
                        class="mb-0 small text-muted"
                        [innerHTML]="
                            'footer-logo-descriptor' | cmsText | jpText | async
                        "
                    ></p>
                </div>
                <div class="col-4 text-end">
                    <p class="mb-0 small text-muted">
                        &copy; iChoosr {{ year }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>
